import { Injectable } from '@angular/core';
import { TradeInstructionsComponent } from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import {orderTypes} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.model";
@Injectable({
	providedIn: 'root',
  })
export class GetDestinationQ {
	setDestination(parent:TradeInstructionsComponent) {
		const self = parent;
		let qString = (self.notHeldDestinationSelected) ? (((self.notHeldDestinationSelected.id == "AOM_PRINTER")) ? "ORDERTYPEONLY" : "BLOCKDESK") : "BLOCKDESK"; //IREBALUX-3342
		if (qString == "BLOCKDESK") {
	
		  /**
		   * @description IREBALUX-1338 Trailing Stop $ and Trailing Stop % Order Types are only available on Sell and Sell All orders (not Buys)
		   * @param {boolean} isNotHeld the not held checkbox
		   * @param {boolean} isTrailingStopAvailable the isTrailingStopAvailable is for set boolean based on the condition reached.
		   */
			//Defect #153070 - Order Blotter > Edit Trade Instructions for Multiple Securities > Different Symbols > Stop and Stop Limit Displayed in Order Type Drop-down
		  const isTrailingStopAvailable = ((self.data.showAllTransactionTypeSellAll && !self.notHeld) || ((self.data.transactionType == "SELL" || self.data.transactionType == "SELL_ALL") && !self.notHeld && self.actionType != "MultiEdit"));
	
	
		  if (self.notHeld) { //IREBALUX-3342
				self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'ARRIVAL');
		  } else if (self.blockdeskrecordspresent && self.isShowNotHeldVarious && self.data.quantity < 3000) {
				self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'ORDERTYPEONLY');
			}
		  else if (self.data.showAllOrderTypeSelections || self.actionType != "MultiEdit") { //TDA.Testing - Defect #153404 - [STE06] iRebal: Some order types are not present when user unchecks Not Held checkbox
			/** IREBALUX-1213
			 * If 1 equity or option order is selected (1 symbol), the Edit Trade Instructions modal launched from
			 * the new button should allow the user to specify the order type as either Stop or Stop Limit (same as in-line single order edit).
			 * It should use the same order validations as the in-line edit.
			 * */
				if (isTrailingStopAvailable) { // all items
					self.orderTypes = self.getFilteredArray(orderTypes, 'trailingStopAvailable', 'TRUE');
				} else { // NONSELLALL
					self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'NONSELLALL');
				}
		  }
		  else {
		  	if (isTrailingStopAvailable) {
					self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'BLOCKDESK');
				} else {
		  		if (self.sameSymbol) {
						self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'NONSELLALL');
					} else {
						self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'ARRIVAL');
					}
				}
		  }
		}
	  }
	
}
